// Number of results fetched per search request.
export const SEARCH_RESULTS_PER_PAGE = 20;

// Caps the dropdown to roughly 5 visible options and makes the rest scrollable.
export const AUTOCOMPLETE_LISTBOX_PROPS = {
  style: { maxHeight: 220, overflow: "auto" },
};
